var collapsible_list_component_default = {
  "ltr": "_0UUm1",
  "rtl": "AzC28",
  "iconContainer": "Kibkr",
  "icon": "kxyxe",
  "isExpanded": "xj9D6",
  "listDimensions": "VDtfx"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
